import md5 from 'js-md5'
/* 
md5加密方式
*/
const SecretKey = "f34nr32fh843Sddf%$fmidVR4f32_3"; //加密秘钥字符串key

function objKeySort(obj) {
  var newkey = Object.keys(obj).sort();
  var newObj = {};
  var newObjStr = "";
  for (var i = 0; i < newkey.length; i++) {
    newObj[newkey[i]] = obj[newkey[i]];
  }
  Object.keys(newObj).forEach(function (key) {
    if (obj[key] != undefined) {
      newObjStr += key + "=" + obj[key];
    } else {
      newObjStr += key + "=" + "";
    }
  });
  const yrMd5 = ("yr" + newObjStr).replace(/[\r\n]/g, "");
  return yrMd5;
}

export function encrypt(params) {
	let data = {
	  platform_flag: "1",
	  timestamp: new Date().getTime(),
	  ...params,
	};
	let signData = {...data};
	if (signData.hasOwnProperty("file")) {
	  delete signData.file;
	}
	data.sign = md5(SecretKey + objKeySort(signData)).toUpperCase();
	return data;
}